function view (path) {
  return () => import(/* webpackChunkName: 'fso-v2' */ '@/views/fso/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RFso = [
  {
    path: '/fso/dashboard',
    component: view('Dashboard'),
    name: 'fso.dashboard'
  },
  {
    path: '/fso/customers',
    component: view('Customers'),
    name: 'fso.customers',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  },
  {
    path: '/fso/customers/:customer?/managements',
    component: view('customer-management/Base'),
    name: 'fso.customers.profile',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Customers',
          to: {
            name: 'fso.customers'
          }
        },
        {
          text: 'Customer Profile',
          active: true
        }
      ]
    }
  },
  {
    path: '/fso/leads',
    component: view('Leads'),
    name: 'fso.leads',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Leads',
          active: true
        }
      ]
    }
  },
  {
    path: '/fso/leads/:lead?/managements',
    component: view('lead-management/Base'),
    name: 'fso.leads.profile',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Leads',
          to: {
            name: 'fso.leads'
          }
        },
        {
          text: 'Lead Profile',
          active: true
        }
      ]
    }
  }
]

const RFsoToDos = [
  {
    path: '/fso/to-dos/customer-memos',
    component: view('customer-memos/Base'),
    children: [
      {
        path: '',
        name: 'fso.to-dos.customer-memos.redirect',
        redirect: {
          name: 'fso.to-dos.customer-memos.pending'
        }
      },
      {
        path: 'pending',
        component: view('customer-memos/Pending'),
        name: 'fso.to-dos.customer-memos.pending',
        meta: {
          breadcrumb: [
            {
              text: 'FSO',
              to: {
                name: 'fso.dashboard'
              }
            },
            {
              text: 'Customer Memos'
            },
            {
              text: 'Pending',
              active: true
            }
          ]
        }
      },
      {
        path: 'processing',
        component: view('customer-memos/Processing'),
        name: 'fso.to-dos.customer-memos.processing',
        meta: {
          breadcrumb: [
            {
              text: 'FSO',
              to: {
                name: 'fso.dashboard'
              }
            },
            {
              text: 'Customer Memos'
            },
            {
              text: 'Processing',
              active: true
            }
          ]
        }
      },
      {
        path: 'history',
        component: view('customer-memos/History'),
        name: 'fso.to-dos.customer-memos.history',
        meta: {
          breadcrumb: [
            {
              text: 'FSO',
              to: {
                name: 'fso.dashboard'
              }
            },
            {
              text: 'Customer Memos'
            },
            {
              text: 'History',
              active: true
            }
          ]
        }
      },
      {
        path: 'documents',
        component: view('customer-memos/Documents'),
        name: 'fso.to-dos.customer-memos.documents',
        meta: {
          breadcrumb: [
            {
              text: 'FSO',
              to: {
                name: 'fso.dashboard'
              }
            },
            {
              text: 'Customer Memos'
            },
            {
              text: 'Documents',
              active: true
            }
          ]
        }
      }
    ]
  },
  {
    path: '/fso/to-dos/tasks',
    component: view('tasks/Base'),
    name: 'fso.to-dos.tasks',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Tasks',
          active: true
        }
      ]
    }
  },
  {
    path: '/fso/to-dos/task-events/:task?/events',
    component: view('task-events/Base'),
    name: 'fso.to-dos.task-events',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Tasks',
          to: {
            name: 'fso.to-dos.tasks'
          }
        },
        {
          text: 'Events',
          active: true
        }
      ]
    }
  },
  {
    path: '/fso/to-dos/activity-recordings/:activity?',
    component: view('activity-recordings/Base'),
    name: 'fso.to-dos.activity-recordings',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Activity Recordings',
          active: true
        }
      ]
    }
  },
  {
    path: '/fso/to-dos/monthly-plans',
    component: view('monthly-plans/Base'),
    name: 'fso.to-dos.monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'FSO',
          to: {
            name: 'fso.dashboard'
          }
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  }
]

export default RFso.concat(
  RFsoToDos
)
